import React, { createContext, useContext, useState, useEffect } from 'react';

const PrintContext = createContext();

export const PrintProvider = ({ children }) => {
  const [isPrinting, setIsPrinting] = useState(false);

  const startPrintProcess = (prepareForPrint) => {
    // console.log('Starting print process');
    setIsPrinting(true);
    if (prepareForPrint) {
      prepareForPrint();
    }
    // setTimeout(() => {
    window.print();
    // }, 100); // Adjust the delay as needed
  };

  useEffect(() => {
    const handleAfterPrint = () => {
      setIsPrinting(false);
    };

    window.addEventListener('afterprint', handleAfterPrint);

    return () => {
      window.removeEventListener('afterprint', handleAfterPrint);
    };
  }, []);

  return <PrintContext.Provider value={{ isPrinting, startPrintProcess }}>{children}</PrintContext.Provider>;
};

export const usePrint = () => useContext(PrintContext);
